export default __webpack_public_path__ + "assets/static/data/tos.3dce816551f9e76268d0ff50d47aea4e.json";